export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Welcome to MyStorageX',
  'login.description': 'MyStorageX is your cloud storage assistant, providing secure and convenient file storage and management services. Access all your files anytime, anywhere.',
  'login.email.placeholder': 'Email or username',
  'login.password.placeholder': 'Password',
  'login.button': 'Login',
  'login.loading': 'Logging in...',
  'login.divider': 'or login with',
  'login.signup': 'No account yet?',
  'login.signup.link': 'Sign up now',
  'login.error.default': 'Login failed, please try again later',
  'login.success': 'Login successful',
  'login.forgotPassword': 'Forgot password?',
  'login.forgotPassword.link': 'Click here to reset',
  'signup.page.title': 'Sign Up - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Welcome to MyStorageX',
  'signup.description': 'Create your account and start your cloud storage journey',
  'signup.username.placeholder': 'Enter username',
  'signup.email.placeholder': 'Enter email',
  'signup.password.placeholder': 'Enter password',
  'signup.confirmPassword.placeholder': 'Confirm password',
  'signup.button': 'Sign Up',
  'signup.loading': 'Signing up...',
  'signup.login': 'Already have an account?',
  'signup.login.link': 'Login now',
  'signup.error.passwordMismatch': 'Passwords do not match',
  'signup.error.default': 'Sign up failed, please try again later',
  'signup.success': 'Sign up successful',
  'resetPassword.page.title': 'Reset Password - MyStorageX',
  'resetPassword.page.description': 'Reset your MyStorageX account password',
  'resetPassword.title': 'Reset Password',
  'resetPassword.email.placeholder': 'Enter your email address',
  'resetPassword.code.placeholder': 'Enter verification code',
  'resetPassword.password.placeholder': 'Enter new password',
  'resetPassword.button': 'Reset Password',
  'resetPassword.button.loading': 'Resetting...',
  'resetPassword.backToLogin': 'Back to Login',
  'resetPassword.sendCode': 'Get Code',
  'resetPassword.sendCode.sending': 'Sending...',
  'resetPassword.sendCode.retry': 'Retry in {seconds}s',
  'resetPassword.error.emailRequired': 'Please enter your email address',
  'resetPassword.error.codeRequired': 'Please enter verification code',
  'resetPassword.error.passwordRequired': 'Please enter new password',
  'resetPassword.error.passwordLength': 'Password must be 6-20 characters',
  'resetPassword.error.codeLength': 'Verification code must be 6 digits',
  'resetPassword.success.codeSent': 'Verification code has been sent to your email',
  'resetPassword.success.reset': 'Password reset successful',
  'resetPassword.error.sendFailed': 'Failed to send verification code, please try again later',
  'resetPassword.error.resetFailed': 'Failed to reset password, please try again later',
  'signup.username.rule.length': 'Username must be 4-10 characters',
  'signup.username.rule.format': 'Only letters, numbers, underscores and hyphens are allowed',
  'signup.password.rule.length': 'Password must be 6-20 characters',
  'signup.password.rule.lowercase': 'Must contain lowercase letters',
  'signup.password.rule.uppercase': 'Must contain uppercase letters',
  'signup.password.rule.number': 'Must contain numbers',
  'signup.password.rule.special': 'Must contain special characters',
  'login.verificationCode.placeholder': 'Enter verification code',
  'login.verificationCode.send': 'Get Code',
  'login.verificationCode.sending': 'Sending...',
  'login.verificationCode.retry': 'Retry in {seconds}s',
  'login.verificationCode.success': 'Verification code sent',
  'login.verificationCode.error': 'Failed to send verification code',
  'login.verificationCode.required': 'Please enter verification code',
  'login.verificationCode.invalid': 'Invalid verification code format',
  'signup.verificationCode.placeholder': 'Enter verification code',
  'signup.verificationCode.send': 'Get Code',
  'signup.verificationCode.sending': 'Sending...',
  'signup.verificationCode.retry': 'Retry in {seconds}s',
  'signup.verificationCode.success': 'Verification code sent',
  'signup.verificationCode.error': 'Failed to send code',
  'signup.verificationCode.required': 'Please enter verification code',
  'signup.verificationCode.invalid': 'Invalid verification code format',
  'signup.error.emailRequired': 'Please enter your email address',
  'signup.announcement': 'Registration function is under maintenance today!',
  'sidebar.allFiles': 'All Files',
  'sidebar.starred': 'Starred',
  'sidebar.folders': 'Folders',
  'sidebar.trash': 'Trash',
  'sidebar.decrypt': 'Decrypt Tool',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'About',
  'sidebar.productLog': 'Product Log',
  'productLog.title': 'Product Updates',
  'filelist.column.name': 'Name',
  'filelist.column.size': 'Size',
  'filelist.column.updateTime': 'Modified',
  'filelist.column.recycletime': 'Recycle Time',
  'filelist.column.actions': 'Actions',
  'filelist.total': 'Total {total} items',
  'filelist.action.upload': 'Upload',
  'filelist.action.newFolder': 'New Folder',
  'filelist.action.refresh': 'Refresh',
  'filelist.action.search': 'Search files',
  'filelist.action.batchDownload': 'Download',
  'filelist.action.batchDelete': 'Delete',
  'filelist.action.download': 'Download',
  'filelist.action.preview': 'Preview',
  'filelist.action.rename': 'Rename',
  'filelist.selected': '{count} selected',
  'page.cloudDrive.title': 'My Cloud Drive',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Securely store and manage your files',
  'modal.fileUpload.title': 'Upload Files',
  'modal.fileUpload.dragText': 'Drag files here, or click to upload',
  'modal.fileUpload.start': 'Start Upload',
  'modal.fileUpload.cancel': 'Cancel',
  'modal.fileUpload.clear': 'Clear List',
  'modal.fileUpload.encrypt': 'Encrypt Selected',
  'modal.fileUpload.addMore': 'Add More',
  'modal.fileUpload.remove': 'Remove',
  'modal.fileUpload.error.noSelection': 'Please select files to remove',
  'modal.fileUpload.error.noEncryption': 'Please select files to encrypt',
  'modal.fileUpload.error.noClear': 'No files to clear',
  'modal.fileUpload.error.noStart': 'No files to upload',
  'modal.fileUpload.error.noCancel': 'No uploading files to cancel',
  'modal.fileUpload.error.fileSize': 'File size exceeds limit',
  'modal.fileUpload.error.fileType': 'File type not supported',
  'modal.fileUpload.error.maxCount': 'Maximum file count exceeded',
  'modal.fileUpload.duplicate.title': 'File already exists',
  'modal.fileUpload.duplicate.skip': 'Skip',
  'modal.fileUpload.duplicate.replace': 'Replace',
  'modal.fileUpload.duplicate.rename': 'Rename',
  'modal.fileUpload.status.pending': 'Pending',
  'modal.fileUpload.status.uploading': 'Uploading',
  'modal.fileUpload.status.success': 'Success',
  'modal.fileUpload.status.error': 'Error',
  'modal.fileUpload.status.cancelled': 'Cancelled',
  'modal.fileUpload.status.duplicated': 'Duplicated',
  'modal.fileUpload.table.filename': 'Filename',
  'modal.fileUpload.table.size': 'Size',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Progress',
  'modal.fileUpload.table.actions': 'Actions',
  'modal.fileUpload.speed': 'Upload Speed',
  'modal.fileUpload.remainingTime': 'Time Remaining',
  'modal.fileUpload.total.progress': 'Total Progress',
  'modal.fileUpload.error.message': 'Upload failed: {message}',
  'modal.fileUpload.confirm.clear': 'Are you sure you want to clear the upload list?',
  'modal.fileUpload.confirm.cancel': 'Are you sure you want to cancel the upload?',
  'modal.fileUpload.clear.mobile': 'Clear',
  'modal.fileUpload.encrypt.mobile': 'Encrypt',
  'modal.fileUpload.addMore.mobile': 'Add',
  'security.features.title': 'Security Features',
  'security.features.localDecryption.title': 'Local Decryption',
  'security.features.localDecryption.description': 'All decryption operations are performed locally in your browser, ensuring your file content and password never leave your device',
  'security.features.militaryEncryption.title': 'Military-grade Encryption',
  'security.features.militaryEncryption.description': 'Using AES-256-CBC encryption algorithm, the most secure symmetric encryption standard that can resist all known attacks',
  'security.features.privacyProtection.title': 'Privacy Protection',
  'security.features.privacyProtection.description': 'Strict privacy protection mechanism, no decryption passwords are saved, no file content is recorded',
  'security.features.smartDecryption.title': 'Smart Chunk Decryption',
  'security.features.smartDecryption.description': 'Using smart chunk decryption technology to significantly improve decryption speed while reducing memory usage',
  'security.features.learnMore': 'Learn More',
  'security.features.modal.title': 'AES-256-CBC Encryption Algorithm Details',
  'security.features.modal.close': 'Close',
  'decrypt.security.modal.title': 'Security Notice',
  'decrypt.security.modal.description': 'All decryption operations are performed locally, your password and file content will never be uploaded to server',
  'decrypt.security.modal.vip.title': 'Dear VIP user, you can:',
  'decrypt.security.modal.vip.feature1': 'Decrypt files of any size',
  'decrypt.security.modal.vip.feature2': 'Use smart chunk decryption for better efficiency',
  'decrypt.security.modal.vip.feature3': 'Support batch decryption of large files',
  'decrypt.security.modal.free.title': 'Important: Decryption process requires browser memory about 3x the file size.',
  'decrypt.security.modal.free.feature1': 'Free users are limited to 4GB per file',
  'decrypt.security.modal.free.feature2': 'Upgrade to VIP to decrypt files of any size',
  'decrypt.security.modal.free.feature3': 'If browser crashes, consider upgrading to use chunk decryption',
  'security.diagram.plaintext.block1': 'Plaintext Block 1',
  'security.diagram.plaintext.block2': 'Plaintext Block 2',
  'security.diagram.ciphertext.block1': 'Ciphertext Block 1',
  'security.diagram.ciphertext.block2': 'Ciphertext Block 2',
  'security.diagram.key': 'Key',
  'security.diagram.aes.encryption': 'AES Encryption',
  'security.diagram.xor.operation': 'XOR Operation',
  'security.diagram.iv': 'Initialization Vector',
  'security.features.aes.what': 'What is AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC is an implementation of the Advanced Encryption Standard, where:',
  'security.features.aes.detail.1': 'A symmetric encryption algorithm established by the US National Institute of Standards and Technology (NIST) in 2001',
  'security.features.aes.detail.2': 'Uses 256-bit key length, providing the highest level of security',
  'security.features.aes.detail.3': 'Cipher Block Chaining (CBC) mode provides better encryption security',
  'security.features.aes.how': 'How It Works',
  'security.features.aes.process': 'The AES-256-CBC encryption process includes the following steps:',
  'security.features.aes.step1': 'Split plaintext data into fixed-size blocks (128 bits)',
  'security.features.aes.step2': 'Generate random initialization vector (IV)',
  'security.features.aes.step3': 'XOR the previous ciphertext block with current plaintext block using CBC mode',
  'security.features.aes.step4': 'Use 256-bit key to perform AES encryption on XOR result',
  'security.features.aes.example': 'Encryption Process Example:',
  'security.features.aes.security': 'Security Features',
  'security.features.aes.security.intro': 'AES-256-CBC provides multiple security guarantees:',
  'security.features.aes.security.point1': '256-bit key provides 2^256 possible combinations, impossible to brute force even with a supercomputer',
  'security.features.aes.security.point2': 'CBC mode ensures identical plaintext blocks produce different ciphertext blocks, increasing encryption randomization',
  'security.features.aes.security.point3': 'Use of initialization vector (IV) ensures that even with the same key, each encryption produces a different result',
  'security.features.aes.security.point4': 'Widely used in military, financial, and other high-security domains',
  'security.features.chunk.title': 'Smart Chunk Decryption Technology',
  'security.features.chunk.what': 'What is Smart Chunk Decryption?',
  'security.features.chunk.description': 'Smart chunk decryption is an optimized decryption technology for large files that splits large files into multiple chunks for parallel processing, with the following features:',
  'security.features.chunk.feature1.title': 'Dynamic Chunking',
  'security.features.chunk.feature1.desc': 'Automatically adjusts chunk size based on file size and system memory',
  'security.features.chunk.feature2.title': 'Parallel Processing',
  'security.features.chunk.feature2.desc': 'Multiple data blocks are decrypted simultaneously, fully utilizing multi-core CPUs',
  'security.features.chunk.feature3.title': 'Memory Optimization',
  'security.features.chunk.feature3.desc': 'Controls memory usage through stream processing to prevent memory overflow',
  'security.features.chunk.feature4.title': 'Resume Support',
  'security.features.chunk.feature4.desc': 'Supports continuing after interruption, improving fault tolerance',
  'security.features.chunk.how': 'How It Works',
  'security.features.chunk.process': 'The smart chunk decryption process includes the following steps:',
  'security.features.chunk.step1': 'File Analysis: Calculate optimal chunk size and count',
  'security.features.chunk.step2': 'Data Chunking: Split encrypted file into equal-sized chunks',
  'security.features.chunk.step3': 'Parallel Decryption: Multiple chunks are decrypted simultaneously',
  'security.features.chunk.step4': 'Stream Writing: Decrypted chunks are written to target file in sequence',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Performance Advantages',
  'security.features.chunk.performance.intro': 'Compared to traditional one-time decryption, smart chunk decryption has significant advantages:',
  'security.features.chunk.performance.point1': 'Memory usage reduced by up to 90%, only 400MB needed for a 4GB file',
  'security.features.chunk.performance.point2': '3-5x faster decryption speed, fully utilizing multi-core CPUs',
  'security.features.chunk.performance.point3': 'Supports decryption of large files (>4GB), not limited by browser memory',
  'security.features.chunk.performance.point4': 'Visual decryption process with accurate progress and time remaining',
  'security.features.chunk.usage': 'Use Cases',
  'security.features.chunk.usage.intro': 'Smart chunk decryption is particularly suitable for the following scenarios:',
  'security.features.chunk.usage.point1': 'Decryption of large files (e.g., videos, database backups)',
  'security.features.chunk.usage.point2': 'Decryption operations on memory-constrained devices (e.g., mobile devices)',
  'security.features.chunk.usage.point3': 'Batch file decryption requiring parallel processing',
  'security.features.chunk.usage.point4': 'Decryption tasks requiring real-time progress feedback',
  'security.features.chunk.diagram': 'Smart Chunk Decryption Process Diagram',
  'decrypt.diagram.title': 'Smart Chunk Decryption Process',
  'decrypt.diagram.encryptedFile': 'Encrypted File',
  'decrypt.diagram.smartChunking': 'Smart Chunking',
  'decrypt.diagram.parallelDecryption': 'Parallel Decryption',
  'decrypt.diagram.decryptedFile': 'Decrypted File',
  'decrypt.diagram.memoryOptimization': 'Memory Usage Optimization',
  'decrypt.diagram.memoryUsage': 'Only Uses ~10% Memory',
  'decrypt.diagram.realTimeFeedback': 'Real-time Progress',
  'decrypt.fileList.column.name': 'Filename',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Actions',
  'decrypt.fileList.status.pending': 'Pending',
  'decrypt.fileList.status.decrypting': 'Decrypting',
  'decrypt.fileList.status.success': 'Success',
  'decrypt.fileList.status.error': 'Error',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'No files, please add files to decrypt',
  'common.unknown': 'Unknown',
  'common.speed': 'Speed',
  'common.timeSpent': 'Time Spent',
  'common.remaining': 'Remaining',
  'decrypt.upload.dragText': 'Click or drag files',
  'decrypt.upload.hint': 'Support batch .encrypted files, max {maxSize} per file',
  'decrypt.upload.button.decrypt': 'Decrypt Selected',
  'decrypt.upload.button.clear': 'Clear List',
  'decrypt.fileInfo.modal.title': 'File Information',
  'decrypt.fileInfo.modal.close': 'Close',
  'decrypt.fileInfo.name': 'File Name',
  'decrypt.fileInfo.size': 'File Size',
  'decrypt.fileInfo.type': 'File Type',
  'decrypt.fileInfo.lastModified': 'Last Modified',
  'decrypt.fileInfo.status': 'Status',
  'decrypt.fileInfo.progress': 'Progress',
  'decrypt.fileInfo.speed': 'Speed',
  'decrypt.fileInfo.timeRemaining': 'Time Remaining',
  'decrypt.fileInfo.timeSpent': 'Time Spent',
  'decrypt.fileInfo.error': 'Error Message',
  'page.decrypt.title': 'MyStorage File Decryption Tool',
  'page.decrypt.subtitle': 'Securely decrypt your files with zero data loss',
  'page.decrypt.helmet.title': 'File Decryption Tool - MyStorage',
  'page.decrypt.helmet.description': 'Secure file decryption tool - Decrypt your files locally in browser to protect your privacy',
  'filelist.modal.newFolder.title': 'New Folder',
  'filelist.modal.newFolder.placeholder': 'Enter folder name',
  'filelist.modal.newFolder.ok': 'Create',
  'filelist.modal.newFolder.cancel': 'Cancel',
  'language.selector.title': 'Select Language',
  'filelist.modal.rename.title': 'Rename',
  'filelist.modal.rename.placeholder': 'Enter new name',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Cancel',
  'decrypt.password.modal.title': 'Enter Decryption Password',
  'decrypt.password.modal.placeholder': 'Enter password',
  'decrypt.password.modal.hint': 'Enter the password you set during encryption, it will only be used for local decryption',
  'decrypt.message.invalidFile': 'Please select only .encrypted files',
  'decrypt.message.duplicate': 'File "{filename}" already exists, automatically deduped',
  'decrypt.message.oversizeTitle': 'File size exceeds limit',
  'decrypt.message.oversizeContent': 'Following files exceed free user limit (4GB):',
  'decrypt.message.oversizeHint': 'Upgrade to VIP to decrypt files of any size',
  'decrypt.message.selectFile': 'Please select files to decrypt',
  'decrypt.message.enterPassword': 'Please enter decryption password',
  'decrypt.message.decryptSuccess': 'File {filename} has been saved',
  'decrypt.message.saveCancel': 'Cancelled saving file {filename}',
  'decrypt.message.downloadSuccess': 'File {filename} has been saved to downloads',
  'decrypt.message.decryptError': 'Failed to decrypt file {filename}: {error}',
  'decrypt.message.batchError': 'Batch decryption failed, please try again',
  'sideMenu.storageInfo.title': 'Storage Space',
  'sideMenu.storageInfo.usage': 'Used {used} / Total {total}',
  'sideMenu.storageStats.title': 'Storage Statistics',
  'sideMenu.storageStats.overview': 'Overview',
  'sideMenu.storageStats.totalFiles': 'Total Files',
  'sideMenu.storageStats.totalSize': 'Total Size',
  'sideMenu.storageStats.fileTypes': 'File Type Distribution',
  'sideMenu.storageStats.providers': 'Service Providers',
  'common.default': 'Default',
  'common.regionCode': 'Region Code',
  'common.nodeType': 'Node Type',
  'common.storageUsed': 'Used Space',
  'common.storageAvailable': 'Available Space',
  'common.storageLimit': 'Total Capacity',
  'common.storageUsageDetail': 'Used {used} / Total {total}',
  'common.defaultNode': 'Default Node',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.latency': 'Latency',
  'common.retry': 'Retry',
  
  // Node Selection
  'cloudDrive.nodeSelect.title': 'Select Storage Node',
  'cloudDrive.nodeSelect.addNode': 'Add Storage Node',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirm Delete Node',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Are you sure to delete node "{nodeName}"? This action cannot be undone!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Node deleted successfully',
  'cloudDrive.nodeSelect.deleteFailed': 'Failed to delete node',
  
  // Node Creation
  'cloudDrive.nodeCreate.title': 'Add Storage Node',
  'cloudDrive.nodeCreate.selectProvider': 'Select Cloud Provider',
  'cloudDrive.nodeCreate.nodeName': 'Node Name',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Leave empty to use default name',
  'cloudDrive.nodeCreate.nameMaxLength': 'Node name cannot exceed 50 characters',
  'cloudDrive.nodeCreate.noProviders': 'No available cloud providers',
  'cloudDrive.nodeCreate.pingLatency': 'Latency {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Testing latency...',
  'cloudDrive.nodeCreate.pingFailed': 'Latency test failed',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latency not available',
  'cloudDrive.nodeCreate.sortByLatency': 'Sort by latency',
  'cloudDrive.nodeCreate.selectRegion': 'Select Region',
  'cloudDrive.nodeCreate.selectedRegion': 'Selected Region',
  'cloudDrive.nodeCreate.noRegions': 'No regions available',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Please select a cloud provider',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Please select a cloud provider first',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Please select a region first',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Failed to load cloud providers list',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Failed to load regions list',
  'cloudDrive.nodeCreate.nodeType': 'Node Type',
  'cloudDrive.nodeCreate.nodeType.standard': 'Standard Storage',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Low Frequency Storage',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archive Storage',
  'cloudDrive.nodeCreate.storageLimit': 'Storage Limit',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Please enter storage limit',
  'cloudDrive.nodeCreate.storageLimitMin': 'Storage limit cannot be less than 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Enter storage limit (GB)',
  'cloudDrive.nodeCreate.success': 'Storage node created successfully',
  'cloudDrive.nodeCreate.failed': 'Failed to create storage node',
  
  // Node Edit
  'cloudDrive.nodeEdit.title': 'Edit Node',
  'cloudDrive.nodeEdit.name': 'Node Name',
  'cloudDrive.nodeEdit.nameRequired': 'Please enter node name',
  'cloudDrive.nodeEdit.nameMaxLength': 'Node name cannot exceed 50 characters',
}; 